import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import t from '../../lib/lng';
import { COOKIE_KEY, cookieUtils } from '@app/app/cookie';

const CookiePopup = ({ close }) => {
  const [popupShown, setPopupShown] = useState(false);

  setTimeout(() => {
    setPopupShown(true);
  }, 2000);

  function onClickBtn() {
    cookieUtils.set(COOKIE_KEY.cookieAccepted, 1, { sameSite: 'strict' });
    close();
  }

  return (
    <div className={'cookie_popup' + (popupShown ? ' go' : '')}>
      <div className="cookie_popup__text">
        {t.cookiePopupText}{' '}
        <Link className="cookie_popup__link" to="/legal/cookie" target="_blank">
          {t.CookiePolicy.toLowerCase()}
        </Link>
      </div>
      <div className="cookie_popup_btn" onClick={onClickBtn}>
        {t.formatString(t.GotIt, <span>&nbsp;</span>)}
      </div>
    </div>
  );
};

export default CookiePopup;
